import React from 'react'
import './pSecTwo.scss'
import { sec2 } from '../../data/PhotoData';
import logo from '../../assest/signature_copy.webp'
import img from '../../assest/img1.webp'
import SocialMediaPhoto from '../../component/SocialMediaPhoto';
import shapes from '../../assest/mandala.webp';


function PhotoSecTwo() {
  return (
    <div className='p-sec-t-container'>
        <div className='p-sec-t-inner'>
                <div className='photo-logo'>
                     <img src={logo}  alt="" />
                </div>
               
                <h1>{sec2.heading}</h1>
                <p>{sec2.des1}</p>
                <p>{sec2.des2}</p>
                <p>{sec2.des3}</p>
                <div>
                    <SocialMediaPhoto/>
                </div>
        </div>

        <div className='back-shape'>
            <img className='bk-shape-one' src={shapes} />
        </div>
        <div className='back-shape'>
            <img className='bk-shape-two' src={shapes} />
        </div>
    </div>
  )
}

export default PhotoSecTwo;